import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

export class CustomRouteReuseStrategy extends BaseRouteReuseStrategy {
    override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        // Se la rotta futura ha il flag reuse impostato a false, non riutilizzarla
        if (future.data && future.data['reuse'] === false) {
            return false;
        }
        // Altrimenti mantieni il comportamento standard di Angular
        return future.routeConfig === curr.routeConfig;
    }
}